module.exports = __webpack_public_path__ + "fonts/Arzypto-Dashboard.c237eb8.eot";